var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"md":"auto"}},[_c('amplify-authenticator',{attrs:{"authConfig":{ signInConfig: { isSignUpDisplayed: false } }}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }